module.exports = __webpack_public_path__ + "4dbf0b3dc911d12a6773936d4ebb5a87.svg";